<template lang='pug'>
  .fpui-store-packages
    fpui-packages(
      @select='onSelect',
      @install='onInstall'
      @remove='onRemove'
      @buy='onBuy'
      @version='onVersion'
      @edit='onEdit'
      @closeDetail='onCloseDetail'
      :consumer='consumer',
      :type='type',
    )
</template>

<script>
import FpuiPackages from '@/components/Packages'

export default {
  components: { FpuiPackages },
  computed: {
    consumer () { return this.$route.params.consumer },
    type () { return this.$route.params.type }
  },
  created () {
    if (this.$route.query.active) {
      this.$store.commit('PACKAGES_SET_ACTIVE', this.$route.query.active)
    }
  },
  methods: {
    onSelect (item) {
      this.$store.commit('PACKAGES_SET_ACTIVE', item.id)
      this.$sendMessage('PACKAGES_SELECT_ITEM', item)
    },
    onCloseDetail (item) { this.$sendMessage('PACKAGES_CLOSE_DETAIL', item) },
    onInstall (item) { this.$sendMessage('PACKAGES_INSTALL_MODULE', item) },
    onRemove (item) { this.$sendMessage('PACKAGES_REMOVE_MODULE', item) },
    onBuy (item) { this.$sendMessage('PACKAGES_BUY_MODULE', item) },
    onVersion (item) { this.$sendMessage('PACKAGES_VERSION_MODULE', item) },
    onEdit (item) { this.$sendMessage('PACKAGES_EDIT_MODULE', item) }
  }
}
</script>

<style lang='less'>
  .fpui-store-packages {

  }
</style>
